import { render, staticRenderFns } from "./Cells.vue?vue&type=template&id=2cc6b7e8&"
import script from "./Cells.vue?vue&type=script&lang=js&"
export * from "./Cells.vue?vue&type=script&lang=js&"
import style0 from "./Cells.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports